import FormDialog from './FormDialog.vue';

FormDialog.install = function install(Vue) {
  Vue.component(FormDialog.name, FormDialog);
};

export default FormDialog;



// WEBPACK FOOTER //
// ./src/components/formDialog/index.js